import { ReactNode } from "react";
import "./styles.scss";
import {
  AdinEight,
  AdinFive,
  AdinFour,
  AdinNine,
  AdinOne,
  AdinSeven,
  AdinSix,
  AdinTen,
  AdinThree,
  AdinTwo,
} from "@/assets";

export default function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="auth-layout__container">
      <div className="auth-layout__page">{children}</div>
      
      <div className="auth-layout__right">
        <AdinOne />
        <AdinTwo />
        <AdinThree />
        <AdinFour />
        <AdinFive />
        <AdinSix />
        <AdinSeven />
      </div>
    </div>
  );
}
